import {
  TREATMENT_CREATE_RETROSPECTIVE_VISIT_REQUEST,
  TREATMENT_CREATE_RETROSPECTIVE_VISIT_FAILURE,
} from '../../../actions/constants/types';

const initialState = {
  errorMessage: null,
};

function previewedCompletedTreatment(state = initialState, action) {
  switch (action.type) {
    case TREATMENT_CREATE_RETROSPECTIVE_VISIT_REQUEST:
      return {
        ...state,
        errorMessage: null,
      };
    case TREATMENT_CREATE_RETROSPECTIVE_VISIT_FAILURE:
      return {
        ...state,
        errorMessage: action.message.translationKey,
      };
    default:
      return state;
  }
}

export default previewedCompletedTreatment;
